import React, { useState } from 'react';

const CollectionOverview = ({ totalSongs, totalCategories, largestCategory, categoriesWithSongs }) => {
    const [open, setOpen] = useState(false);

    const stats = [
        { icon: '📁', label: 'Categories', value: totalCategories, color: '#f9d57b' },
        { icon: '🎵', label: 'Total Songs', value: totalSongs, color: '#f5bc40' },
        { icon: '⭐', label: 'Largest Category', value: largestCategory, color: '#d4a017' },
        { icon: '✅', label: 'Active Categories', value: categoriesWithSongs, color: '#b8860b' },
    ];

    return (
        <>
            {/* Floating Overview Button — top right */}
            <button
                id="collection-overview-btn"
                className="overview-fab"
                onClick={() => setOpen(true)}
                aria-label="Collection Overview"
                title="View Collection Overview"
            >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
                    <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
                    <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
                    <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
                </svg>
                <span className="overview-fab-label">Collection Overview</span>
            </button>

            {/* Overlay */}
            {open && (
                <div className="overview-overlay" onClick={() => setOpen(false)}>
                    <div className="overview-panel" onClick={(e) => e.stopPropagation()}>
                        {/* Close */}
                        <button className="overview-close" onClick={() => setOpen(false)} aria-label="Close">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                            </svg>
                        </button>

                        {/* Header */}
                        <div className="overview-header">
                            <div className="overview-header-icon">📊</div>
                            <h3 className="overview-title">Collection Overview</h3>
                            <p className="overview-subtitle">Idhaya Ragam Sacred Songs</p>
                        </div>

                        {/* Stats Grid */}
                        <div className="overview-stats-grid">
                            {stats.map((s, i) => (
                                <div className="overview-stat-card" key={i} style={{ animationDelay: `${i * 0.07}s` }}>
                                    <div className="overview-stat-icon">{s.icon}</div>
                                    <div className="overview-stat-value" style={{ color: s.color }}>{s.value}</div>
                                    <div className="overview-stat-label">{s.label}</div>
                                </div>
                            ))}
                        </div>

                        {/* Quote */}
                        <div className="overview-quote">
                            <span className="overview-quote-cross">✝</span>
                            <p>"Sing to the Lord a new song; sing to the Lord, all the earth."</p>
                            <span className="overview-quote-ref">— Psalm 96:1</span>
                        </div>

                        {/* Footer note */}
                        <div className="overview-footer">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" fill="currentColor" />
                            </svg>
                            Click any song to open on YouTube
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CollectionOverview;
